module.exports = __webpack_public_path__ + "media/images/athletes/3122-43a284d76f9dfb1f7b90f8c4ccb0cdf4.png";